import { render, staticRenderFns } from "./CommunityDetail.vue?vue&type=template&id=170cd3d0&"
import script from "./CommunityDetail.vue?vue&type=script&lang=js&"
export * from "./CommunityDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommunityDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./CommunityDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports